import React, { useState, useEffect } from "react";
import Content from "../../../components/Content";
import { ServiceDetailsTabs } from "../../../constants/ServiceConstants";
import { ServiceOverviewView } from "./ServiceOverviewView";

export const ServiceDetailsView = () => {
  const [lastTab, setLastTab] = useState(1);

  useEffect(() => {
    let lastTab = JSON.parse(localStorage.getItem("lastTab"));
    if (lastTab) {
      setLastTab(lastTab);
    }
  }, []);
  return (
    <>
      <Content
        tabs={true}
        tabList={ServiceDetailsTabs}
        lastTab={lastTab}
        title={"Tjänst"}
      >
        <div value={1}>
          <ServiceOverviewView />
        </div>
        <div value={2}></div>
      </Content>
    </>
  );
};
